import { createStyles } from "@mantine/core";
import { colors, pxToRem } from "theme";

export const useStyles = createStyles(() => ({
  damagedPartsGrid: {
    maxWidth: "340px",
  },
  damagedPartContainerWrapper: {
    width: "158px",
  },
  damagedPartContainer: {
    borderRadius: "7px",
    position: "relative",
    cursor: "pointer",
    borderWidth: "2px",
    borderStyle: "solid",
    WebkitTapHighlightColor: "transparent",
  },
  damagedPartLabel: {
    height: "auto",
    minHight: "37px",
    lineHeight: pxToRem[24],
    padding: "8px",
    backgroundColor: colors.white,
    left: 0,
    width: "100%",
    wordBreak: "break-word",
  },
  checkIcon: {
    position: "absolute",
    background: colors.white,
    borderRadius: "50%",
    top: "13px",
    right: "11px",
  },
}));
